/**
 * 되돌리기 어려운 삭제 앞에 두는 2단계 확인.
 *
 * 왜 두 단계인가: 회원·지점·기기는 **적립 이력과 실회원 포인트가 딸려 있다.**
 *   목록에서 버튼 하나로 지워지면 옆줄을 눌러 다른 대상을 지우는 사고가 난다.
 *   그래서 ① 의사를 묻고 ② `Delete` 를 손으로 치게 한다 — 손이 한 번 더 가야 한다.
 *
 * ⚠️ 입력값은 **대소문자를 구분한다.** `delete`, `DELETE` 는 통과하지 않는다.
 *    "실수로 엔터"를 막는 것이 목적이라 느슨하게 받으면 의미가 없다.
 *
 * @param {string} what  무엇을 지우는지 (예: "지점 '안양 본사1'")
 * @returns {boolean}    실제로 지워도 되면 true
 */
export default function confirmHardDelete(what) {
  if (!window.confirm(`${what}을(를) 정말 삭제하시겠습니까?`)) return false;

  const typed = window.prompt(
    `되돌릴 수 없습니다.\n계속하려면 Delete 를 그대로 입력하세요.\n\n대상: ${what}`
  );
  if (typed === null) return false; // 취소

  if (typed !== 'Delete') {
    window.alert('입력이 일치하지 않아 삭제하지 않았습니다.');
    return false;
  }
  return true;
}
